import { render } from "./DetachIso.vue?vue&type=template&id=396a9e27&scoped=true"
import script from "./DetachIso.vue?vue&type=script&lang=js"
export * from "./DetachIso.vue?vue&type=script&lang=js"

import "./DetachIso.vue?vue&type=style&index=0&id=396a9e27&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396a9e27"]])

export default __exports__